// Hotels section filters and sorting
document.addEventListener('DOMContentLoaded', function() {
    // Слайдер на странице отеля (вызываем первым, до return)
    initHotelSlider();

    const filterButtons = document.querySelectorAll('.hotel-filter-btn');
    const hotelCards = document.querySelectorAll('.hotel-card[data-category]');
    const sortSelect = document.querySelector('.hotels-page-sort-select');
    const countValue = document.querySelector('.hotels-page-count-value');
    const hotelsList = document.querySelector('.hotels-list');
    const loadMoreBtn = document.querySelector('.hotels-load-more-btn');

    // Выходим если нет необходимых элементов на странице
    if ((filterButtons.length === 0 && !sortSelect) || hotelCards.length === 0) {
        // На страницах без фильтров (например, страница отдельного отеля) запускаем загрузку рейтингов сразу
        initTophotelsWidgets();
        return;
    }

    let currentFilter = 'all';
    let currentSort = 'default';
    // На главной странице (нет сортировки) — лимит 6, на странице отелей — 25
    const isMainPage = !sortSelect;
    let visibleLimit = isMainPage ? 6 : 25;
    const loadMoreStep = isMainPage ? 6 : 25; // Сколько подгружать по кнопке

    // Сохраняем исходный порядок карточек (как пришли с сервера)
    hotelCards.forEach((card, index) => {
        card.setAttribute('data-original-order', index);
    });
    
    // Set first button as active and apply styles
    if (filterButtons.length > 0) {
        const firstButton = filterButtons[0];
        firstButton.classList.add('active');
        firstButton.style.backgroundColor = '#7C3AED';
        firstButton.style.color = 'white';
        firstButton.style.boxShadow = '0 4px 6px rgba(124, 58, 237, 0.3)';
    }
    
    // Получаем карточки, соответствующие текущему фильтру
    // data-category может содержать несколько категорий через пробел (например "all beach luxury")
    function getFilteredCards() {
        const filter = currentFilter.toLowerCase();
        return Array.from(hotelCards).filter(card => {
            const cardCategories = (card.getAttribute('data-category') || 'all').trim().toLowerCase().split(/\s+/);
            if (filter === 'all') return true;
            return cardCategories.includes(filter);
        });
    }

    // Функция сортировки массива карточек
    function sortCardsArray(cards) {
        return cards.sort((a, b) => {
            switch (currentSort) {
                case 'price-low':
                    return parseInt(a.getAttribute('data-price') || '0', 10) - parseInt(b.getAttribute('data-price') || '0', 10);
                case 'price-high':
                    return parseInt(b.getAttribute('data-price') || '0', 10) - parseInt(a.getAttribute('data-price') || '0', 10);
                case 'rating':
                    return parseFloat(b.getAttribute('data-rating') || '0') - parseFloat(a.getAttribute('data-rating') || '0');
                case 'popular':
                    return parseInt(b.getAttribute('data-reviews') || '0', 10) - parseInt(a.getAttribute('data-reviews') || '0', 10);
                default: // default - сохраняем серверный порядок
                    return parseInt(a.getAttribute('data-original-order') || '0', 10) - parseInt(b.getAttribute('data-original-order') || '0', 10);
            }
        });
    }

    // Функция для обновления счетчика
    function updateCount() {
        if (countValue) {
            const filteredCards = getFilteredCards();
            countValue.textContent = filteredCards.length;
        }
    }

    // Обновление кнопки "Показать ещё"
    function updateLoadMoreButton() {
        if (!loadMoreBtn) return;
        const filteredCards = getFilteredCards();
        if (filteredCards.length > visibleLimit) {
            loadMoreBtn.style.display = 'inline-flex';
            loadMoreBtn.textContent = 'Показать ещё (' + (filteredCards.length - visibleLimit) + ')';
        } else {
            loadMoreBtn.style.display = 'none';
        }
    }

    // Функция для применения фильтров, сортировки и лимита
    function applyFiltersAndSort() {
        // Сначала скрываем все карточки
        hotelCards.forEach(card => {
            card.style.display = 'none';
        });

        // Получаем отфильтрованные и отсортированные карточки
        let filteredCards = getFilteredCards();
        filteredCards = sortCardsArray(filteredCards);

        // Перемещаем карточки в DOM в правильном порядке и показываем до лимита
        filteredCards.forEach((card, index) => {
            if (hotelsList) {
                hotelsList.appendChild(card);
            }
            if (index < visibleLimit) {
                card.style.display = '';
            }
        });

        updateCount();
        updateLoadMoreButton();
    }
    
    
    // Обработчики для фильтров
    filterButtons.forEach(button => {
        button.addEventListener('click', function() {
            const filter = this.getAttribute('data-filter');
            currentFilter = filter;
            visibleLimit = isMainPage ? 6 : 25; // Сбрасываем лимит при смене фильтра

            // Update active button
            filterButtons.forEach(btn => {
                btn.classList.remove('active');
                btn.style.backgroundColor = '';
                btn.style.color = '';
                btn.style.boxShadow = '';
            });
            this.classList.add('active');
            this.style.backgroundColor = '#7C3AED';
            this.style.color = 'white';
            this.style.boxShadow = '0 4px 6px rgba(124, 58, 237, 0.3)';

            applyFiltersAndSort();
        });
    });

    // Обработчик для сортировки
    if (sortSelect) {
        sortSelect.addEventListener('change', function() {
            currentSort = this.value;
            visibleLimit = isMainPage ? 6 : 25; // Сбрасываем лимит при смене сортировки
            applyFiltersAndSort();
        });
    }

    // Обработчик кнопки "Показать ещё"
    if (loadMoreBtn) {
        loadMoreBtn.addEventListener('click', function() {
            visibleLimit += loadMoreStep;
            applyFiltersAndSort();
        });
    }

    // Инициализация
    applyFiltersAndSort();

    // Единый загрузчик TopHotels рейтингов (Hero + Hotels)
    // Запускаем ПОСЛЕ applyFiltersAndSort, чтобы observer видел только показанные карточки
    initTophotelsWidgets();

    // Обработчик кликов на кнопки "Подробнее" для перехода в SAMO
    document.querySelectorAll('.hotel-select-btn[data-samo-url]').forEach(btn => {
        btn.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            const samoUrl = this.getAttribute('data-samo-url');
            if (samoUrl) {
                window.location.href = samoUrl;
            }
        });
    });
    
    // Обработчик кликов на карточки отелей для перехода в SAMO
    document.querySelectorAll('.hotel-card[data-samo-url]').forEach(card => {
        card.style.cursor = 'pointer';
        card.addEventListener('click', function(e) {
            // Не обрабатываем клик, если кликнули на кнопку или ссылку
            if (e.target.closest('.hotel-select-btn') || e.target.closest('a')) {
                return;
            }
            const samoUrl = this.getAttribute('data-samo-url');
            if (samoUrl) {
                window.location.href = samoUrl;
            }
        });
    });

});

// Инициализация слайдера отеля
function initHotelSlider() {
    console.log('initHotelSlider called');

    const slider = document.querySelector('.hotel-slider');
    console.log('slider element:', slider);
    if (!slider) {
        console.log('No .hotel-slider element found');
        return;
    }

    const mainImage = slider.querySelector('.hotel-slider-image');
    const prevBtn = slider.querySelector('.hotel-slider-prev');
    const nextBtn = slider.querySelector('.hotel-slider-next');
    const thumbs = slider.querySelectorAll('.hotel-slider-thumb');
    const currentCounter = slider.querySelector('.hotel-slider-current');

    console.log('mainImage:', mainImage);
    console.log('prevBtn:', prevBtn);
    console.log('nextBtn:', nextBtn);
    console.log('thumbs count:', thumbs.length);

    if (!mainImage || thumbs.length === 0) {
        console.log('No mainImage or no thumbs, returning');
        return;
    }

    // Собираем слайды из миниатюр
    let slides = [];
    thumbs.forEach((thumb, i) => {
        const img = thumb.querySelector('img');
        console.log('Thumb', i, 'img:', img, 'src:', img ? img.getAttribute('src') : 'none');
        if (img) {
            slides.push({ src: img.getAttribute('src'), alt: img.alt || '' });
        }
    });

    console.log('Total slides collected:', slides.length);

    if (slides.length <= 1) {
        console.log('Only 1 or fewer slides, slider not needed');
        return;
    }

    console.log('Slider initialized with', slides.length, 'slides');

    let currentIndex = 0;

    function updateSlider(index) {
        if (index < 0) index = slides.length - 1;
        if (index >= slides.length) index = 0;

        currentIndex = index;

        // Плавная смена картинки
        mainImage.style.opacity = '0';
        setTimeout(() => {
            mainImage.src = slides[currentIndex].src;
            mainImage.alt = slides[currentIndex].alt || '';
            mainImage.style.opacity = '1';
        }, 250);

        // Обновляем счётчик
        if (currentCounter) {
            currentCounter.textContent = currentIndex + 1;
        }

        // Обновляем активную миниатюру
        thumbs.forEach((thumb, i) => {
            if (i === currentIndex) {
                thumb.classList.add('active');
            } else {
                thumb.classList.remove('active');
            }
        });
    }

    // Обработчики кнопок prev/next
    if (prevBtn) {
        prevBtn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            console.log('Prev clicked, current:', currentIndex);
            updateSlider(currentIndex - 1);
        });
    }
    if (nextBtn) {
        nextBtn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            console.log('Next clicked, current:', currentIndex);
            updateSlider(currentIndex + 1);
        });
    }

    // Обработчики миниатюр
    thumbs.forEach((thumb, index) => {
        thumb.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            console.log('Thumb clicked, index:', index);
            updateSlider(index);
        });
    });

    // Клавиатурная навигация
    document.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') {
            updateSlider(currentIndex - 1);
        } else if (e.key === 'ArrowRight') {
            updateSlider(currentIndex + 1);
        }
    });

    // Свайп для мобильных
    let touchStartX = 0;
    let touchEndX = 0;

    mainImage.addEventListener('touchstart', (e) => {
        touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    mainImage.addEventListener('touchend', (e) => {
        touchEndX = e.changedTouches[0].screenX;
        const diff = touchStartX - touchEndX;
        if (Math.abs(diff) > 50) {
            if (diff > 0) {
                updateSlider(currentIndex + 1);
            } else {
                updateSlider(currentIndex - 1);
            }
        }
    }, { passive: true });
}

// Единый загрузчик виджетов TopHotels рейтинга (Hero + Hotels)
// Ленивая загрузка: рейтинг грузится когда карточка попадает в область видимости
// Каждый hotel ID грузится ОДИН раз, результат копируется во все совпадающие виджеты
function initTophotelsWidgets() {
    var allWidgets = document.querySelectorAll('.hero-tophotels-widget[data-tophotels-id], .tophotels-widget[data-tophotels-id]');
    if (allWidgets.length === 0) return;

    var uid = 'a3324eb4494efd667b4823fecef98512';
    var fixedPlaceId = 'th_rating_default_' + uid + '_default';

    // Кеш загруженных рейтингов: { hotelId: htmlContent }
    var ratingCache = {};
    // Очередь на загрузку (последовательно, т.к. общий temp-контейнер)
    var loadQueue = [];
    var isLoading = false;

    // Счётчик для уникальных ID обёрток (нужен для CSS-селектора [id^="th_rating_"])
    var wrapperCounter = 0;

    // Применяет рейтинг к виджету (из кеша или после загрузки)
    function applyRating(widget, content) {
        var wrapper = document.createElement('div');
        wrapper.id = 'th_rating_widget_' + (wrapperCounter++);
        wrapper.innerHTML = content;
        widget.innerHTML = '';
        widget.appendChild(wrapper);

        // Скрываем виджет если рейтинг = 0
        var ratingEl = wrapper.querySelector('.rating-review-block__rating-global');
        if (ratingEl) {
            var ratingText = ratingEl.textContent.trim();
            if (ratingText === '0' || ratingText === '0.0' || ratingText === '0,0') {
                widget.style.display = 'none';
            }
        }
    }

    // Последовательная загрузка из очереди
    function processQueue() {
        if (isLoading || loadQueue.length === 0) return;

        var item = loadQueue.shift();
        var hotelId = item.hotelId;
        var widgets = item.widgets;

        // Если уже в кеше — сразу применяем
        if (ratingCache[hotelId]) {
            widgets.forEach(function(w) { applyRating(w, ratingCache[hotelId]); });
            processQueue();
            return;
        }

        isLoading = true;

        var tempContainer = document.getElementById(fixedPlaceId);
        if (!tempContainer) {
            tempContainer = document.createElement('div');
            tempContainer.id = fixedPlaceId;
            tempContainer.style.display = 'none';
            document.body.appendChild(tempContainer);
        }
        tempContainer.innerHTML = '';

        var script = document.createElement('script');
        script.src = 'https://partner-v2.tophotels.ru/rating/default/' + hotelId + '/simple?uid=' + uid + '&mode=default';

        script.onload = function() {
            setTimeout(function() {
                if (tempContainer.innerHTML) {
                    var content = tempContainer.innerHTML;
                    ratingCache[hotelId] = content;
                    widgets.forEach(function(w) { applyRating(w, content); });
                }
                isLoading = false;
                processQueue();
            }, 300);
        };

        script.onerror = function() {
            isLoading = false;
            processQueue();
        };

        document.body.appendChild(script);
    }

    // Добавляет виджет в очередь на загрузку
    function enqueueWidget(widget) {
        var hotelId = widget.getAttribute('data-tophotels-id');
        if (!hotelId) return;

        // Если уже в кеше — сразу применяем, не ставим в очередь
        if (ratingCache[hotelId]) {
            applyRating(widget, ratingCache[hotelId]);
            return;
        }

        // Проверяем, есть ли уже этот hotelId в очереди — добавляем виджет к существующему
        var found = false;
        for (var i = 0; i < loadQueue.length; i++) {
            if (loadQueue[i].hotelId === hotelId) {
                loadQueue[i].widgets.push(widget);
                found = true;
                break;
            }
        }
        if (!found) {
            loadQueue.push({ hotelId: hotelId, widgets: [widget] });
        }

        processQueue();
    }

    // IntersectionObserver — грузим рейтинг когда карточка видна на экране
    var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            if (entry.isIntersecting) {
                observer.unobserve(entry.target);
                enqueueWidget(entry.target);
            }
        });
    }, { rootMargin: '200px' }); // Начинаем грузить за 200px до появления на экране

    allWidgets.forEach(function(widget) {
        observer.observe(widget);
    });
}

